/* eslint-disable no-console */
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { EnvModeType } from './app/enums/env-mode-type.enum';
import { environment } from './environments/environment';

const ENVS_LOGS_ALLOWED = [EnvModeType.DEV, EnvModeType.LOCAL];
if (!ENVS_LOGS_ALLOWED.includes(environment.mode)) {
    //remove all console logs
    console.log = function () {
        // do nothing
    };
}
bootstrapApplication(AppComponent, appConfig).catch((err: unknown) => {
    console.error(err);
});
